import { createRoot } from 'react-dom/client';
import App from './App';
import store from './logic/store/store';
import { Provider } from 'react-redux';
import './styles/layout.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
const root = createRoot(document.getElementById('root'));
root.render(<Provider store={store}><App /></Provider>);